export default __webpack_public_path__ + "static/media/ClawAnimatedHQ.8911e6ed.gif";